import { render } from "./AccountVerificationDialog.vue?vue&type=template&id=e656972e"
import script from "./AccountVerificationDialog.vue?vue&type=script&lang=js"
export * from "./AccountVerificationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__